export enum Medium {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}
